// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"2024":"16d04f59","3816":"16d04f59","4084":"16d04f59","5673":"16d04f59","8724":"16d04f59","9645":"16d04f59","9807":"16d04f59"}[chunkId] + ".chunk.css";
};